var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTooltipButton',_vm._b({staticClass:"theme--light v-size--default primary",attrs:{"id":_vm.idName,"icon":_vm.icon},on:{"click":_vm.generate}},'BaseTooltipButton',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Export")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }